module.exports = __webpack_public_path__ + "media/Images/about-hero-image-e484b4ffa076e084066034e870743abf.jpg";